// Module
var code = "HELP";
// Exports
module.exports = code;